import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import ThemeDefault from '../../theme-default';
import axios from 'axios';
import urlBase from '../../url-base';


class ChangePassword extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      newPassword: '',
      confirmation: '',
      errorFormat: ''
    };

    this.styles = {
      loginContainer: {
        minWidth: 320,
        maxWidth: 400,
        height: 'auto',
        position: 'absolute',
        top: '11%',
        left: 0,
        right: 0,
        margin: 'auto'
      },
      loginContainerResponse: {
        minWidth: 320,
        maxWidth: 800,
        height: 'auto',
        position: 'absolute',
        top: '11%',
        left: 0,
        right: 0,
        margin: 'auto'
      },      
      paper: {
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop:40,
        paddingBottom:30,
        overflow: 'auto',
        marginTop: 30, 
        height:340,
      },
      loginBtn: {
        float: 'right'
      },
      logo: {
        width: 344,
        height:64,
        backgroundImage:  'url(' + require('../../assets/images2/new_layout/logo_dental_plano_odontologico.svg') + ')',
        backgroundSize:'100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        margin: '0px auto 30px auto'
      },
      img_background: {
        width: "100%",
        height:400,
        backgroundImage:  'url(' + require('../../assets/images2/background-login.png') + ')',
        backgroundSize:'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        margin: '0px auto 0px auto',
        bottom:0,
        position:'absolute',
      },
      h1: {
        textAlign: 'center',
        fontSize: 28,
        fontWeight: 500,
        color: '#d10424',
        marginBottom: 0,
        textTransform: 'uppercase',
      },
      h2: {
        textAlign: 'center',
        fontSize: 22,
        fontWeight: 500,
        color: '#757575',
        marginBottom: 0,
        textTransform: 'uppercase',
      },
      h3: {
        textAlign: 'center',
        fontSize: 18,
        fontWeight: 500,
        color: '#d10424',
        marginBottom: 0

      }       
    };

    this.errorField = {
      confirmation: ''
    };

    this.errorFormat = {
      email: ''
    };
    let params = new URLSearchParams(window.location.search);
    this.token =  {
      value : params.get('access_token')
    };
    //console.log("Recuperando parametro = " + this.token.value);
  }

  onChange(e) {
    let state = this.state;
    state[e.target.name] = e.target.value;

    if (e.target.type === 'newPassord')
      this.onBlurField(e);

    if (e.target.value === '')
      this.errorField[e.target.name] = 'Campo obrigatório';
    else
      this.errorField[e.target.name] = '';

    this.setState(state);
  }

  // Valida campos em branco (form login)
  validationFields() {
    let fields = ['newPassword', 'confirmation'];
    let message = 'Campo obrigatório';

    for (let i = 0; i < fields.length; i++) {
      if (this.state[fields[i]] === '') {
        this.errorFormat[fields[i]] = message;
        this.setState(this.state);
        return false;
      }
      else
        this.errorFormat[fields[i]] = '';
    }
    this.setState(this.state);
    return true;
  }

  onSubmitForm(e){
    e.preventDefault(e);
    document.getElementById('i_error_submit').style.display = 'none';
    
    this.setState({ isMensagem: false });

      if (this.state.newPassword !== this.state.confirmation) {
        document.getElementById('i_error_submit').innerHTML = 'Informe a senha de confirmação igual a nova senha';
        document.getElementById('i_error_submit').style.display = 'block';     

      } else {

      let options = {
        newPassword: this.state.newPassword
      };
      axios.post(urlBase.loopBack + "Accounts/reset-password?access_token=" + this.token.value, options)
      .then((result) => {  
        if (result.status == 204) { 
          document.getElementById('paper_senha').style.display = 'none';
          document.getElementById('id_container').style = this.styles.loginContainerResponse;
          document.getElementById('div_mensagem').style.display = 'block';           
          //console.log("valor sucesso  "+ result.data);
          document.getElementById('i_mensagem').innerHTML = "A sua senha foi alterada com sucesso. Clique <a href="+ urlBase.client+"panel>aqui</a>, para acessar a página de autenticação de usuário.";
          document.getElementById('i_mensagem').style.display = 'block';   
  
        } else {
          document.getElementById('i_mensagem').innerHTML = "Operação não realizada. Erro :"+result.status;
          document.getElementById('i_mensagem').style.display = 'block';           
         
        }

  
     }).catch(function (erro) {
        document.getElementById('paper_senha').style.display = 'none';
        document.getElementById('id_container').style = this.styles.loginContainerResponse;
        document.getElementById('div_mensagem').style.display = 'block';        
        if (erro.response.data.error.code == "AUTHORIZATION_REQUIRED") {
          //console.log("valor AUTHORIZATION_REQUIRED" + this.state.resultado);
          document.getElementById('i_mensagem').innerHTML = 'Não foi possível realizar a mudança de senha. Favor, realizar uma nova solicitação';
          document.getElementById('i_mensagem').style.display = 'block';   

        } else {
           if (erro.response.data.error.code == "INVALID_TOKEN") {  
            //console.log("valor INVALID_TOKEN" + this.state.resultado);
            document.getElementById('i_mensagem').innerHTML = "Solicitação expirada ou token inválido. Acesse a página de login clicando <a href="+ urlBase.client+"panel>aqui</a> e faça uma nova solicitação.";
            document.getElementById('i_mensagem').style.display = 'block';              
          
           } else {  
  
              document.getElementById('i_mensagem').innerHTML = 'Houve um problema não identificado na sua solicitação de redefinição de senha.';
              document.getElementById('i_mensagem').style.display = 'block';  
           }
        }
      }.bind(this));    
  
    }

  }
  render() {
    return (
      
      <MuiThemeProvider muiTheme={ThemeDefault}>
        <div>
          <div style={this.styles.img_background}>{""}</div>
          <div id="id_container" style={this.styles.loginContainer}>


          <div style={this.styles.logo}>&nbsp;</div>
          <h1 style={this.styles.h1}>Painel Administrativo</h1>
          <h1 style={this.styles.h2}>Planos Dental Center</h1>
          <div id="div_mensagem" style={{ display: "none"}} >
              <Paper  style={this.styles.paper}  >
                    <p id="i_mensagem"
                    style={{color: "rgb(244, 67, 54)", display: "none",   textAlign: 'center'
                  }}
                  />
            </Paper>

          </div>          

          <div style={{display: "block"}} >
                <Paper id="paper_senha" style={this.styles.paper}  >                  
                  <form onSubmit={this.onSubmitForm.bind(this)} >
                    <p
                      id="i_error_submit"
                      style={{color: "rgb(244, 67, 54)", display: "none"}}
                    >
                      Dados incorretos. Tente novamente.
                    </p>
                    
                    <TextField
                      errorText={this.errorFormat.password}
                      hintText="Nova senha"
                      floatingLabelText="Nova Senha"
                      type="password"
                      name="newPassword"
                      value={this.state.newPassword}
                      onChange={this.onChange.bind(this)}
                      
                      fullWidth={true}
                    />
                    <TextField
                      errorText={this.errorFormat.password}
                      hintText="Confirmar Nova Senha"
                      floatingLabelText="Confirmar Nova Senha"
                      type="password"
                      name="confirmation"
                      value={this.state.confirmation}
                      onChange={this.onChange.bind(this)}
                      fullWidth={true}
                    />                
                    <div>
                      <RaisedButton
                        label="ALTERAR SENHA"
                        primary={true}
                        style={this.styles.loginBtn}
                        onClick={this.onSubmitForm.bind(this)}
                        type="submit"
                      />
                    </div>

                  </form>
                  </Paper>              
            </div>

          </div>
        </div>


      </MuiThemeProvider>

    );
  }
  
}

export default ChangePassword;



/** WEBPACK FOOTER **
 ** ./src/components/RecoverPassword/ChangePassword.js
 **/